import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const GetNews = createAsyncThunk(
    '/GetNews',
    async () => {
        let url = baseUrl+'getnews';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))
 
        if(response.data.status === "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );




  


  